import { useDispatch, useSelector } from "react-redux";
import { FormProvider, useForm } from "react-hook-form";
import { setSort } from "redux/transaction/slice";
import * as transactionSelector from "redux/transaction/selectors";
import InviteSortDesktop from "../../components/organisms/InviteSortDesktop";
import { TransactionSortType } from "../../types/Transaction";

const InviteSortDesktopContainer = () => {
  const dispatch = useDispatch();
  const methods = useForm();

  const sort = useSelector(transactionSelector.transactionSort);
  const handleSetMethod = (option: TransactionSortType) => {
    dispatch(setSort(option));
  };
  return (
    <FormProvider {...methods}>
      <InviteSortDesktop selected={sort} onSelect={handleSetMethod} />
    </FormProvider>
  );
};

export default InviteSortDesktopContainer;
